import removeNamespace from "../namespace-helper"

export const Types = {
  getters: {},
  actions: {
    PUSH_MESSAGE: "snackbar/PUSH_MESSAGE",
    LINES: "snackbar/LINES",
    SHOW: "snackbar/SHOW",
    HIDE: "snackbar/HIDE",
  },
  mutations: {
    LINES: "snackbar/REVIEWS",
    DISPLAY: "snackbar/DISPLAY",
    TIMER: "snackbar/TIMER",
    COLOR: "snackbar/COLOR",
  },
}

const _types = removeNamespace("snackbar/", Types)

const state = {
  lines: [],
  display: false,
  timer: null,
  color: "error",
}

// getters
const getters = {}

// actions
const actions = {
  [_types.actions.PUSH_MESSAGE]: ({ dispatch, commit }, payload) => {
    commit(_types.mutations.LINES, payload.lines)

    if (payload.hasOwnProperty("config")) {
      const config = payload.config

      if (config.hasOwnProperty("timeout")) {
        commit(
          _types.mutations.TIMER,
          window.setTimeout(() => {
            dispatch(_types.actions.HIDE)
          }, config.timeout)
        )
      }

      if (config.hasOwnProperty("color")) {
        commit(_types.mutations.COLOR, config.color)
      }
    }

    dispatch(_types.actions.SHOW)
  },
  [_types.actions.LINES]: ({ commit }, lines) => {
    commit(_types.mutations.LINES, lines)
  },
  [_types.actions.SHOW]: ({ commit }) => {
    commit(_types.mutations.DISPLAY, true)
  },
  [_types.actions.HIDE]: ({ commit }) => {
    commit(_types.mutations.DISPLAY, false)
  },
}

// mutations
const mutations = {
  [_types.mutations.LINES]: (state, lines) => {
    state.lines = lines
  },
  [_types.mutations.DISPLAY]: (state, display) => {
    state.display = display
  },
  [_types.mutations.TIMER]: (state, timer) => {
    state.timer = timer
  },
  [_types.mutations.COLOR]: (state, color) => {
    state.color = color
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
